module.exports = __webpack_public_path__ + "static/photo9-b34d93b5daa65696aa625b86d9b0b3e0.jpg";